export const SERVICE_VENT_INSTALL = {
  label: 'Install Venting Components',
  value: 'SERVICE_VENT_INSTALL'
};
export const SERVICE_VENT_ACCESS_DOOR_INSTALL = {
  label: 'Install Access Door',
  value: 'SERVICE_VENT_ACCESS_DOOR_INSTALL'
};
